import { useState, useEffect } from "react";

const useButtonLoader = () => {
  const [isLoading, setLoading] = useState(false);
  const [element, setElement] = useState({ disabled: false, loading: false });

  useEffect(() => {
    if (isLoading) {
      setElement((prev) => {
        return { ...prev, disabled: true, loading: true };
      });
    } else {
      setElement((prev) => {
        return { ...prev, disabled: false, loading: false };
      });
    }
  }, [isLoading]);

  return [element, setLoading];
};

export default useButtonLoader;
